import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSUfService from '@/services/Cadastros/Gerais/uf.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUfList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSUfService = new SLSUfService();
  const refUfListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'pais.pais_nome', label: 'Pais', sortable: true },
    { key: 'uf_nome', label: 'Uf', sortable: true },
    { key: 'uf_regiao', label: 'Região', sortable: true },
    { key: 'actions', label: 'Ações' },
  ];
  const perPage = ref(10);
  const totalUf = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const searchIdPais = ref(null);
  const sortBy = ref('ufid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refUfListTable.value ? refUfListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUf.value,
    };
  });

  const refetchData = () => {
    refUfListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, searchIdPais, statusFilter], () => {
    refetchData();
  });

  const fetchUf = (ctx, callback) => {
    overlay.value = true;
    sLSUfService.index({
      q: searchQuery.value,
      id_pais: searchIdPais.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalUf.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    await sLSUfService.store(body);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSUfService.update(body.ufid, body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSUfService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchUf,
    tableColumns,
    perPage,
    currentPage,
    totalUf,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUfListTable,
    searchIdPais,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,
    overlay,
    // Extra Filters
    statusFilter,
    removerData,
  };
}
